import { Injectable } from '@angular/core';

@Injectable()
export class webConfig {
    public LFD = 'http://209.97.147.137:8010/';
    public prod = 'http://192.168.231.23:8010/';
    public url = this.LFD;
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/webConfig.ts